import React, { useEffect, useState } from "react"
import { getUser } from "../services/helpers"
import { getAPIBaseURL } from "../services/helpers"
import { getData } from "../services/request"
import { Link } from "react-router-dom"

const HospitalDashboard = () => {
  const user = getUser()
  const [walletBalance, setWalletBalance] = useState(null)
  const [loadingBalance, setLoadingBalance] = useState(true)

  useEffect(() => {
    const fetchBalance = async () => {
      setLoadingBalance(true)
      const url = `${getAPIBaseURL()}/v1/wallet/balance`
      const res = await getData(url, {}, {})
      setLoadingBalance(false)
      if (res.error == "") {
        if (res.result.status === 200) {
          setWalletBalance(res.result.data?.data?.balance || 0)
        }
      }
    }
    fetchBalance()
  }, [])

  const formatCurrency = (amount, currency = 'NGN') => {
    const num = Number(amount)
    if (isNaN(num)) return amount
    return `${currency === 'NGN' ? '₦' : currency} ${num.toLocaleString()}`
  }

  return (
    <div className="mx-auto max-w-6xl px-3 sm:px-0">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Welcome back</h1>
        <p className="mt-1 text-sm text-gray-500">
          {user?.organization || "Hospital"} Dashboard
        </p>
      </div>

      <div className="grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3">
        <div className="rounded-lg bg-white p-6 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gray-100 text-gray-600">
              <svg className="h-7 w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="7" y="3" width="10" height="18" rx="2" />
                <path d="M9 7H15" />
                <path d="M9 11H15" />
                <path d="M9 15H13" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Pending Requests</p>
              <p className="text-2xl font-bold text-gray-900">0</p>
            </div>
          </div>
        </div>

        <div className="rounded-lg bg-white p-6 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gray-100 text-gray-600">
              <svg className="h-7 w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="m9 12 2 2 4-4" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Active Orders</p>
              <p className="text-2xl font-bold text-gray-900">0</p>
            </div>
          </div>
        </div>

        <div className="rounded-lg bg-white p-6 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gray-100 text-gray-600">
              <svg className="h-7 w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 18c3.866 0 7-3.358 7-7.5S15.866 3 12 3 5 6.358 5 10.5 8.134 18 12 18Z" />
                <path d="M12 8v5" />
                <path d="M10 10h4" />
                <path d="M9 21h6" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Wallet Balance</p>
              <p className="text-2xl font-bold text-gray-900">
                {loadingBalance ? "Loading..." : formatCurrency(walletBalance || 0)}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Wallet Quick Access */}
      <div className="mt-6 rounded-lg bg-white p-4 sm:p-6 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Wallet</h2>
            <p className="mt-1 text-sm text-gray-500">View your wallet balance and transaction history</p>
          </div>
          <Link
            to="/hospital/wallet"
            className="rounded-lg bg-black px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-gray-900"
          >
            View Wallet
          </Link>
        </div>
      </div>

      <div className="mt-6 rounded-lg bg-white p-4 sm:p-6 shadow-sm">
        <h2 className="mb-4 text-lg font-semibold text-gray-900">Payout Details</h2>
        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <p className="text-sm font-medium text-gray-500">Account Name</p>
            <p className="text-base font-semibold text-gray-900">{user?.accountName || "Not provided"}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Account Number</p>
            <p className="text-base font-semibold text-gray-900">{user?.accountNumber || "Not provided"}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500">Bank</p>
            <p className="text-base font-semibold text-gray-900">{user?.bank || "Not provided"}</p>
          </div>
        </div>
      </div>

      <div className="mt-6 rounded-lg bg-white p-4 sm:p-6 shadow-sm">
        <h2 className="mb-4 text-lg font-semibold text-gray-900">Recent Activity</h2>
        <div className="text-center py-12 text-gray-500">
          <p className="text-sm">No recent activity</p>
        </div>
      </div>
    </div>
  )
}

export default HospitalDashboard

